export function transformPenniesToDollar(amount: number): string {
  return parseFloat((Number(amount) / 100).toString()).toFixed(2);
}

export function transformDollarToPennies(amount: number): number {
  // There is no decimal data type in JavaScript - the only numeric data type is floating-point.
  // Therefore, to prevent inaccurate results when doing multiplying added Math.round() function
  // returns the value of a number rounded to the nearest integer.
  // see - https://timleland.com/money-in-javascript/
  // also - https://stackoverflow.com/questions/2876536/precise-financial-calculation-in-javascript-what-are-the-gotchas

  return Math.round(amount * 100);
}

export function currencyFormatter(
  amount: number,
  minimumFractionDigits = 2
): string {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
  });
  return formatter.format(amount);
}
